<template>
  <div v-if="isReadyToRender">
    <div v-if="title || (step !== null && step > 1)" class="dialog-header">
      <div class="button-container">
        <v-btn
          v-if="step !== null && step > 1"
          icon
          class="close-btn"
          @click="back"
        >
          <i class="v-icon material-icons">arrow_back_ios</i>
        </v-btn>
      </div>

      <div class="dialog-title" v-if="title">
        {{ title }}
      </div>
      <v-spacer v-else-if="step !== null && step > 1" />

      <div class="button-container">
        <v-btn
          icon
          class="close-btn"
          @click="closeDialog"
        >
          <i class="v-icon material-icons">cancel</i>
        </v-btn>
      </div>
    </div>
    <div v-else class="close-only-container">
      <v-btn
        icon
        class="close-btn absolute-close"
        @click="closeDialog"
      >
        <i class="v-icon material-icons">cancel</i>
      </v-btn>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    step: {
      type: Number,
      default: null
    },

    title: {
      type: String,
      default: ''
    },
    back: {
      type: Function,
      default: () => ''
    },

    closeDialog: {
      type: Function,
      required: true
    }
  },
   data() {
    return {
      isReadyToRender: false
    }
  },
  created() {
    this.$nextTick(() => {
      this.isReadyToRender = true;
    });
  }
}
</script>
<style scoped>
.placeholder-height {
  height: 0;  
}
.dialog-header {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 8px;
  position: relative;
  z-index: 1;
  background-color: #fff;
}

.button-container {
  width: 48px; 
  display: flex;
  justify-content: center;
}

.dialog-title {
  text-align: center;
  font-size: 1.25rem;
  font-weight: 900;
  width: calc(100% - 96px);
}
.close-btn.absolute-close {
  position: absolute !important;
  z-index: 10 !important;
  top: 8px !important;
  right: 8px !important;
}

/* .close-btn.absolute-close:hover,
.close-btn.absolute-close:focus,
.close-btn.absolute-close:active {
  position: absolute !important;
  top: 8px !important;
  right: 8px !important;
  transform: none !important; 
} */

.close-only-container {
  position: relative;
  width: 100%;
  height: 0;
  overflow: visible;
}
.close-btn.absolute-close .v-btn__content {
  position: static !important;
}
</style>